import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdminLayoutModule, GraphQLModule, UiModule } from '@ov-suite/ui';
import { JwtInterceptor } from '@ov-suite/authguard-angular';
import { DomainService, SharedModule } from '@ov-suite/helpers-angular';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '@ov-suite/authguard-angular/lib/authentication/authentication.service';
import { environment } from '@ov-suite/helpers-shared/lib/environments/environment';
import { getUrl } from '@ov-suite/helpers-angular/lib/get-url.helper';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { GlobalErrorHandler } from '@ov-suite/helpers-angular/lib/error.handler';
import { FooterModule } from './shared/footer/footer.module';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppComponent } from './app.component';
import { angularRoutes, sidebarRoutes } from './app.routing';
import { UserService } from './services/user/user.service';

const providers = [];

if (environment.sentryUrl) {
  providers.push([
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]);
}

@NgModule({
  declarations: [AppComponent, AuthLayoutComponent],
  imports: [
    AdminLayoutModule.forRoot({
      projectName: 'Account Link',
      link: 'idm',
      sidebarRoutes,
      angularRoutes,
    }),
    UiModule.forRoot({
      apiUrl: getUrl('api'),
      imageUploadUrl: environment.other.awsFileServiceApi,
    }),
    FooterModule,
    SharedModule,
    GraphQLModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    AuthenticationService,
    DomainService,
    UserService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    ...providers,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
